function m(e, u = 300, t = !1, l) {
  let o = null;
  return function(...i) {
    o && clearTimeout(o), t ? (t = !1, l ? l(e(...i)) : e(...i)) : o = setTimeout(() => {
      l ? l(e(...i)) : e(...i);
    }, u);
  };
}
export {
  m as d
};
//# sourceMappingURL=debounce-CG9EzSwd.js.map
